/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailResponse } from '../models/CompanyDetailResponse';
import type { CompanyEditForm } from '../models/CompanyEditForm';
import type { CompanySearchForm } from '../models/CompanySearchForm';
import type { PageCompanyIndexResponse } from '../models/PageCompanyIndexResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyRepository {

  /**
   * 企業一覧表示
   * @returns PageCompanyIndexResponse OK
   * @throws ApiError
   */
  public static index({
    companyIds,
    externalCompanyIds,
    statuses,
    acquirerIds,
    createdAtStartDateTime,
    createdAtEndDateTime,
    page = 1,
    size = 20,
    sort,
  }: {
    /**
     * 企業ID(複数指定可能)
     */
    companyIds: Array<string> | undefined,
    /**
     * 外部企業ID（複数指定可能）
     */
    externalCompanyIds: Array<string> | undefined,
    /**
     *
     * ステータス(複数指定可能)
     *
     * ※利用開始日、利用終了日、現在日時の比較でアプリ側で設定
     *
     * | ステータス | 条件 |
     * | --- | --- |
     * | 有効待ち | 現在日時 < 利用開始日 |
     * | 有効 | 利用開始日 < 現在日時 < 利用終了日 |
     * | 終了 | 利用終了日 < 現在日時 |
     *
     */
    statuses: Array<'WAITING' | 'AVAILABLE' | 'CLOSED' | 'SMART_CODE_WAITING' | 'SMART_CODE_AVAILABLE'> | undefined,
    /**
     * アクワイアラID(複数指定可能)
     */
    acquirerIds: Array<string> | undefined,
    /**
     * 登録日時(開始日時)　※msまでの日時が検索に反映される
     */
    createdAtStartDateTime: string | undefined,
    /**
     * 登録日時(終了日時)　※msまでの日時が検索に反映される
     */
    createdAtEndDateTime: string | undefined,
    /**
     * One-based page index (1..N)
     */
    page: number | undefined,
    /**
     * The size of the page to be returned
     */
    size: number | undefined,
    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    sort: Array<string> | undefined,
  }): CancelablePromise<PageCompanyIndexResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/company',
      query: {
        'companyIds': companyIds,
        'externalCompanyIds': externalCompanyIds,
        'statuses': statuses,
        'acquirerIds': acquirerIds,
        'createdAtStartDateTime': createdAtStartDateTime,
        'createdAtEndDateTime': createdAtEndDateTime,
        'page': page,
        'size': size,
        'sort': sort,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 企業一覧Csvを生成、ストレージにUploadし、ダウンロードするための署名付きURLを返却する
   * @returns any OK
   * @throws ApiError
   */
  public static downloadCompany({
    requestBody,
  }: {
    requestBody: CompanySearchForm,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/company/download',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 企業詳細表示
   * @returns CompanyDetailResponse OK
   * @throws ApiError
   */
  public static detail({
    id,
  }: {
    /**
     * 企業ID
     */
    id: string,
  }): CancelablePromise<CompanyDetailResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/company/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 企業情報更新
   * @returns any OK
   * @throws ApiError
   */
  public static edit({
    id,
    requestBody,
  }: {
    id: string,
    requestBody: CompanyEditForm,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/company/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

}
